import React from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "./layout/Layout";
import Home from "./pages/Home";
import Favourite from "./pages/Favourite";
import Completed from "./pages/Completed";
import InProgress from "./pages/InProgress";
import NotFound from "./pages/NotFound";

// app compoenent is the root of the application and is responsible for routing
const App: React.FC = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/favourite" element={<Favourite />} />
        <Route path="/completed" element={<Completed />} />
        <Route path="/in-progress" element={<InProgress />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default App;
